document.addEventListener("DOMContentLoaded", function() {
    const overlay = document.getElementById("main-popup-overlay");
    const popupBanner = document.getElementById("main-popup-banner");
    const closePopup = document.getElementById("closePopup");
    const popupButton = document.querySelector(".main-popup-banner-button");
    setTimeout(() => {
      if (localStorage.getItem("popupClosed") !== "true" && window.location.href.indexOf("djamila-rowe-lp") === -1) {
        overlay.style.display = "block";
        popupBanner.style.display = "block";
      }
    }, 20000);
  
      closePopup.addEventListener("click", function(e) {
        e.preventDefault();
        overlay.style.display = "none";
        popupBanner.style.display = "none";
  
        localStorage.setItem("popupClosed", "true");
      });

      if (popupButton) {
        popupButton.addEventListener("click", function(e) {
            if (localStorage.getItem("popupClosed") === "true") {
                e.preventDefault();
            } else {
                closePopupFunction();
            }
        });
      }
  
      function closePopupFunction() {
          overlay.style.display = "none";
          popupBanner.style.display = "none";
          localStorage.setItem("popupClosed", "true");
      }
    
    function updateImageSource() {
      const mainPopupImage = document.querySelector(".main-popup-image img");
      const screenWidth = window.innerWidth;
      if (screenWidth <= 501) {
        // Small gif
        mainPopupImage.src = "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/amazon-tester-popupbanner-mobile.webp?v=1747151094"; 
        popupButton.innerText = "JETZT STARTEN";
      } else {
        // Big gif
        mainPopupImage.src = "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/amazon-tester-popupbanner-desktop.webp?v=1747150467";
        popupButton.innerText = "JETZT STARTEN";
      }
    }
  
    updateImageSource();
  
    window.addEventListener("resize", updateImageSource);
});
  